import { TrackingType } from './CookieBanner.types'

export const DO_NOT_TRACK_PROPERTY_KEY = 'dnt'
export const DO_NOT_TRACK_ADVERTISING_PROPERTY_KEY = 'dnt_a'

export const DEFAULT_TRACKING_PREFERENCES = {
  [TrackingType.ANALYTICS]: false,
  [TrackingType.ADVERTISING]: false,
}

export const TRACKING_TEXT_TRANSLATION_KEYS: {
  [key in TrackingType | 'ESSENTIAL']: { title: any; description: any }
} = {
  ESSENTIAL: {
    title: 'essential-cookies-title',
    description: 'essential-cookies-description',
  },
  [TrackingType.ANALYTICS]: {
    title: 'analytics-cookies-title',
    description: 'analytics-cookies-description',
  },
  [TrackingType.ADVERTISING]: {
    title: 'advertising-cookies-title',
    description: 'advertising-cookies-description',
  },
}
